<template>
  <RevDialog :name="modalName" :title="i18n(translations.title)">
    <template #body>
      <p class="body-1 my-32 text-center">
        {{ i18n(translations.confirmationMessage) }}
      </p>
    </template>
    <template #footer>
      <div class="flex flex-col">
        <RevButton
          data-qa="confirm-payment-button"
          full-width="always"
          :loading="isLoading"
          variant="primary"
          @click="handleConfirm"
        >
          {{ i18n(translations.confirmButton) }}
        </RevButton>
        <RevButton
          class="mt-8"
          data-qa="decline-payment-button"
          full-width="always"
          variant="secondary"
          @click="handleDecline"
        >
          {{ i18n(translations.declineButton) }}
        </RevButton>
      </div>
    </template>
  </RevDialog>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import type { HttpApiError } from '@backmarket/http-api'
import { putRefurbisherOrderValidate } from '@backmarket/http-api/src/api-specs-buyback/seller/refurbisher'
import MODAL_NAMES from '@backmarket/nuxt-layer-buyback/utils/modals'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { RevButton } from '@ds/components/Button'
import { RevDialog } from '@ds/components/Dialog'
import { closeModal } from '@ds/components/ModalBase'

import translations from './SendPaymentModal.translations'

const i18n = useI18n()
const logger = useLogger()

const props = defineProps<{
  orderId: string
}>()
const emit = defineEmits(['confirmed', 'error'])

const modalName = computed(() => MODAL_NAMES.REFURBISHER_ORDER_SEND_PAYMENT)
const isLoading = ref(false)

const handleConfirm = async () => {
  isLoading.value = true

  try {
    await $httpFetch(putRefurbisherOrderValidate, {
      pathParams: {
        id: props.orderId,
      },
    })
    emit('confirmed')
  } catch (err) {
    emit('error')

    logger.error('[BUYBACK][API][ORDER] Error validating order', {
      error: err as HttpApiError,
      owners: ['bot-squad-circularity-order-lifecycle-front'],
    })
  } finally {
    isLoading.value = false
  }

  closeModal(modalName.value)
}

const handleDecline = () => {
  closeModal(modalName.value)
}
</script>
